"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import IconCheckCircle from "@/app/(components)/generics/Icons/IconCheckCircle";
import IconRestart from "@/app/(components)/generics/Icons/IconRestart";
import CircleLoader from "@/app/(components)/generics/loaders/CircleLoader/CircleLoader";
import { Tooltip, TooltipPosition, TooltipType } from "@/app/(components)/generics/Tootlip/Tooltip";
import { useCallInsightScope } from "@/app/hooks/useCallInsightScope";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { CallFile } from "@/app/types/call/CallFile";
import { PageParams } from "@/app/types/common/DefaultProps";
import styles from "./CallInsightToggle.module.css";

type Props = {
  params: PageParams;
  callFile: CallFile;
};

export default function CallInsightToggle(props: Props) {
  const { params, callFile } = props;
  const T = useT();
  const { available, excluded, recounting, canRunPaidActions, handleExclude, handleRecount } =
    useCallInsightScope(params, callFile);

  if (!available) {
    return null;
  }

  if (recounting) {
    return (
      <Tooltip
        content={T(TKey.CALL_ANALYSIS_RECOUNTING)}
        position={TooltipPosition.BOTTOM_LEFT}
        type={TooltipType.GREEN}
        trigger={
          <span className={styles.recounting}>
            <CircleLoader size={16} color="var(--color-green-3)" />
          </span>
        }
      />
    );
  }

  if (excluded) {
    if (!canRunPaidActions) {
      return (
        <Tooltip
          content={T(TKey.CALL_ANALYSIS_INSIGHT_EXCLUDED)}
          position={TooltipPosition.BOTTOM_LEFT}
          type={TooltipType.GREEN}
          trigger={
            <span className={styles.excludedStatic}>
              <IconRestart size={18} />
            </span>
          }
        />
      );
    }
    return (
      <Tooltip
        content={T(TKey.CALL_ANALYSIS_RECOUNT_TOOLTIP)}
        position={TooltipPosition.BOTTOM_LEFT}
        type={TooltipType.GREEN}
        trigger={
          <Button
            params={params}
            isLink={false}
            type={ButtonType.GHOST}
            iconOnly
            min
            className={styles.iconButton}
            beforeIcon={
              <span style={{ display: "flex", color: "var(--color-green-3)" }}>
                <IconRestart size={18} />
              </span>
            }
            onClick={handleRecount}
          />
        }
      />
    );
  }

  return (
    <Tooltip
      content={T(TKey.CALL_ANALYSIS_EXCLUDE_TOOLTIP)}
      position={TooltipPosition.BOTTOM_LEFT}
      type={TooltipType.GREEN}
      trigger={
        <Button
          params={params}
          isLink={false}
          type={ButtonType.GHOST}
          iconOnly
          min
          className={styles.iconButton}
          beforeIcon={
            <span style={{ display: "flex", color: "var(--color-green-3)" }}>
              <IconCheckCircle size={18} />
            </span>
          }
          onClick={handleExclude}
        />
      }
    />
  );
}
